import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { useController } from "../assets/components/BaseContrroler";
import { Typography } from "@mui/material";

function Responasbility() {
  const {
    baseController: { homeController },
  } = useController();
  const { setNavbar, setUrl } = homeController;

  useEffect(() => {
    setUrl("/resposibility");
    setNavbar(true);
  }, [setNavbar, setUrl]);

  return (
    <div className="container py-5" id="about">
      <div className="row align-items-center justify-content-center g-4">
        {/* LEFT IMAGE */}
        <div className="col-12 col-md-5 text-center text-md-start">
          <img
            src={require("../assets/images/responsibility.png")}
            alt="karnafully"
            className="img-fluid rounded shadow-sm"
            style={{
              maxWidth: "100%",
              height: "auto",
              objectFit: "contain",
            }}
          />
        </div>

        {/* RIGHT TEXT CONTENT */}
        <div className="col-12 col-md-7">
          <div className="d-flex align-items-center mb-4">
            <img
              src={require("../assets/images/logo-response.png")}
              alt="logo"
              className="bg-dark p-2 rounded"
              style={{ width: "70px", height: "70px", objectFit: "contain" }}
            />
            <h4 className="fw-bold mb-0 ms-3 lh-sm">
              <span className="text-danger">SOCIAL</span> <br /> RESPONSIBILITY
            </h4>
          </div>

          <Typography
            variant="body1"
            sx={{
              textAlign: "justify",
              lineHeight: 1.8,
              fontSize: "16px",
            }}
          >
            Cognisant of the wider socio-economic environment in which we
            operate, <b>Karnafully International</b> is committed to positively
            impacting people. Through dedicated corporate social responsibility
            (CSR) programmes, we apply a hands-on approach to nurture
            sustainable community development. <br />
            <br />
            During the previous financial year, the Group invested over 1% of
            net profit after tax in Karnafully CSR programmes and is committed
            to increasing this contribution over the coming fiscal. In addition
            to a range of initiatives to ensure the health and safety of
            <b> Karnafully International</b> drivers, our primary focus areas
            are General Library, Human Development Trust and Medical Chamber for
            human welfare and poverty alleviation, through which we invest
            significantly in education-based initiatives.
          </Typography>
        </div>
      </div>
    </div>
  );
}

export default observer(Responasbility);
